import { Link } from 'react-router-dom';

export function LegalFooter() {
  return (
    <footer className="border-t border-border mt-8 py-4 px-4">
      <p className="text-center text-xs text-muted-foreground flex flex-wrap justify-center gap-x-3 gap-y-1">
        <span>© 2026 Sis Thoko</span>
        <span className="hidden sm:inline">·</span>
        <Link to="/privacy" className="hover:text-foreground transition-colors hover:underline underline-offset-2">
          Privacy Policy
        </Link>
        <span>·</span>
        <Link to="/terms" className="hover:text-foreground transition-colors hover:underline underline-offset-2">
          Terms of Service
        </Link>
        <span>·</span>
        <Link to="/help" className="hover:text-foreground transition-colors hover:underline underline-offset-2">
          Help
        </Link>
      </p>
    </footer>
  );
}
